import hotToast from "react-hot-toast";

/**
 * A toast with one Undo button, for a change that is still only in the page
 * (nothing written yet) and is one tap to take back. Its `id` replaces an
 * earlier toast for the same thing instead of stacking a second one.
 */
export function undoToast({ id, message, undoLabel, onUndo }: { id: string; message: string; undoLabel: string; onUndo: () => void }) {
	return hotToast(
		(tt) => (
			<span className="flex items-center gap-[0.875rem]">
				<span className="min-w-0">{message}</span>
				<button
					type="button"
					className="shrink-0 cursor-pointer rounded-[0.25rem] px-[0.25rem] font-bold text-gms-yellow underline-offset-2 hover:underline focus-visible:outline-2 focus-visible:outline-gms-yellow"
					onClick={() => {
						hotToast.dismiss(tt.id);
						onUndo();
					}}
				>
					{undoLabel}
				</button>
			</span>
		),
		{ id, duration: 6000 },
	);
}
